import moment from 'moment';

export function setupMoment(lang: string) {
  moment.locale('ru');
  moment.updateLocale('ru', {
    monthsShort: moment.monthsShort().map((month) => month.substr(0, 3)),
  });
  moment.locale(lang);
}
